export const HELP_TOPICS_RESET_STATE = 'HELP_TOPICS_RESET_STATE';
export const HELP_TOPICS_CURRENT_ITEM = 'HELP_TOPICS_CURRENT_ITEM';

export const HELP_TOPICS_REQUEST_LOADING = 'HELP_TOPICS_REQUEST_LOADING';
export const HELP_TOPICS_REQUEST_SUCCESS = 'HELP_TOPICS_REQUEST_SUCCESS';
export const HELP_TOPICS_REQUEST_FAILED = 'HELP_TOPICS_REQUEST_FAILED';

export const HELP_TOPICS_CURRENT_ACTION = 'HELP_TOPICS_CURRENT_ACTION';
export const HELP_TOPICS_RESET_ACTION = 'HELP_TOPICS_RESET_ACTION';